import { inputTypes } from 'components/common/FormElements/Input'
import { APPLY_COUPON_FORM_FIELD_NAME } from './constants'

export default {
  applyCoupon: {
    name: APPLY_COUPON_FORM_FIELD_NAME,
    label: 'Promo Code',
    inputType: inputTypes.TEXT_INPUT
  }
}
